import { Action } from 'redux';
import { AudienceDetailsStep, DistributionType, IAudience, IDistributionFile, IValidationErrorCollection } from '../../models';
import { AccessCodeType } from '../../models/AccessCodeType';
import { SsoAttribute } from '../../models/SsoAttribute';

export enum ActionTypes {
	AUDIENCE_SET_DEFAULT_STATE = 'AUDIENCE_SET_DEFAULT_STATE',
	AUDIENCE_GET_REQUESTED = 'AUDIENCE_GET_REQUESTED',
	AUDIENCE_GET_SUCCEEDED = 'AUDIENCE_GET_SUCCEEDED',
	AUDIENCE_GET_FAILED = 'AUDIENCE_GET_FAILED',

	AUDIENCE_UPDATE = 'AUDIENCE_UPDATE',
	AUDIENCE_OPEN_CLOSE_DATE_UPDATE = 'AUDIENCE_OPEN_CLOSE_DATE_UPDATE',
	AUDIENCE_EMAIL_TEMPLATE_DATA_UPDATE = 'AUDIENCE_EMAIL_TEMPLATE_DATA_UPDATE',
	AUDIENCE_DISTRIBUTIONS_DATA_UPDATE = 'AUDIENCE_DISTRIBUTIONS_DATA_UPDATE',
	AUDIENCE_DISTRIBUTION_TYPE_UPDATE = 'AUDIENCE_DISTRIBUTION_TYPE_UPDATE',
	AUDIENCE_ACCESS_CODE_TYPE_UPDATE = 'AUDIENCE_ACCESS_CODE_TYPE_UPDATE',

	AUDIENCE_ADD_REQUESTED = 'AUDIENCE_ADD_REQUESTED',
	AUDIENCE_ADD_SUCCEEDED = 'AUDIENCE_ADD_SUCCEEDED',
	AUDIENCE_ADD_FAILED = 'AUDIENCE_ADD_FAILED',

	AUDIENCE_UPDATE_REQUESTED = 'AUDIENCE_UPDATE_REQUESTED',
	AUDIENCE_UPDATE_SUCCEEDED = 'AUDIENCE_UPDATE_SUCCEEDED',
	AUDIENCE_UPDATE_FAILED = 'AUDIENCE_UPDATE_FAILED',

	AUDIENCE_SEND_TEST_EMAIL_REQUESTED = 'AUDIENCE_SEND_TEST_EMAIL_REQUESTED',
	AUDIENCE_SEND_TEST_EMAIL_SUCCEEDED = 'AUDIENCE_SEND_TEST_EMAIL_SUCCEEDED',
	AUDIENCE_SEND_TEST_EMAIL_FAILED = 'AUDIENCE_SEND_TEST_EMAIL_FAILED',

	AUDIENCE_DELETE_REMINDER_WARNING_MODAL_SUCCEEDED = 'AUDIENCE_DELETE_REMINDER_WARNING_MODAL_SUCCEEDED',
	AUDIENCE_EDIT_VALIDATION = 'AUDIENCE_EDIT_VALIDATION',

	AUDIENCE_EDIT_NAVIGATE_STEP = 'AUDIENCE_EDIT_NAVIGATE_STEP',
	UNSAVED_CHANGES_WARNING_MODAL = 'UNSAVED_CHANGES_WARNING_MODAL',
	UNSAVED_CHANGES_CHANGE_DISTRIBUTION_TYPE_WARNING_MODAL = 'UNSAVED_CHANGES_CHANGE_DISTRIBUTION_TYPE_WARNING_MODAL',
	AUDIENCE_DETAILS_LOADING = 'AUDIENCE_DETAILS_LOADING',
	AUDIENCE_DETAILS_INIT_STATE = 'AUDIENCE_DETAILS_INIT_STATE',

	AUDIENCE_DETAILS_SAVING = 'AUDIENCE_DETAILS_SAVING',
	AUDIENCE_DETAILS_SAVE_SUCCESSFUL = 'AUDIENCE_DETAILS_SAVE_SUCCESSFUL',
	AUDIENCE_DETAILS_SAVE_FAILED = 'AUDIENCE_DETAILS_SAVE_FAILED',

	AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_MODAL_TOGGLE = 'AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_MODAL_TOGGLE',
	AUDIENCE_DISTRIBUTION_OPTION_WARNING_MODAL_TOGGLE = 'AUDIENCE_DISTRIBUTION_OPTION_WARNING_MODAL_TOGGLE',
	AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_CLEAR_DATA = 'AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_CLEAR_DATA',

	AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_REQUESTED = 'AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_REQUESTED',
	AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_SUCCEEDED = 'AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_SUCCEEDED',
	AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_FAILED = 'AUDIENCE_DISTRIBUTION_OPTION_DATA_DELETE_FAILED',

	// Audience - Person Attributes
	AUDIENCE_DELETE_ATTRIBUTES_REQUESTED = 'AUDIENCE_DELETE_ATTRIBUTES_REQUESTED',
	AUDIENCE_DELETE_ATTRIBUTES_SUCCEEDED = 'AUDIENCE_DELETE_ATTRIBUTES_SUCCEEDED',
	AUDIENCE_DELETE_ATTRIBUTES_FAILED = 'AUDIENCE_DELETE_ATTRIBUTES_FAILED',
	AUDIENCE_EMAILTEMPLATE_ACCESSCODE_REMOVE = 'AUDIENCE_EMAILTEMPLATE_ACCESSCODE_REMOVE',
	AUDIENCE_SET_TEST_AUDIENCE = 'AUDIENCE_SET_TEST_AUDIENCE',
	AUDIENCE_SET_SSO_ATTRIBUTE_ID = 'AUDIENCE_SET_SSO_ATTRIBUTE_ID',
	TOAST_WARNING_GENERIC_NOTIFICATION = 'TOAST_WARNING_GENERIC_NOTIFICATION',
}

export interface IAudienceDetailsGetRequested extends Action {
	type: ActionTypes.AUDIENCE_GET_REQUESTED;
}
export interface IAudienceDetailsGetSucceeded extends Action {
	type: ActionTypes.AUDIENCE_GET_SUCCEEDED;
	payload: { audience: IAudience };
}
export interface IAudienceDetailsGetFailed extends Action {
	type: ActionTypes.AUDIENCE_GET_FAILED;
}
export interface IAudienceAddRequested extends Action {
	type: ActionTypes.AUDIENCE_ADD_REQUESTED;
}
export interface IAudienceAddSucceeded extends Action {
	type: ActionTypes.AUDIENCE_ADD_SUCCEEDED;
	payload: { audience: IAudience };
}
export interface IAudienceAddFailed extends Action {
	type: ActionTypes.AUDIENCE_ADD_FAILED;
	payload: { audience: IAudience };
}
export interface IAudienceUpdateRequested extends Action {
	type: ActionTypes.AUDIENCE_UPDATE_REQUESTED;
}
export interface IAudienceUpdateSucceeded extends Action {
	type: ActionTypes.AUDIENCE_UPDATE_SUCCEEDED;
	payload: { audience: IAudience };
}
export interface IAudienceUpdateFailed extends Action {
	type: ActionTypes.AUDIENCE_UPDATE_FAILED;
	payload: { audience: IAudience };
}
export interface IAudienceUpdate extends Action {
	type: ActionTypes.AUDIENCE_UPDATE;
	payload: IAudience;
}
export interface IAudienceOpenCloseDateUpdates extends Action {
	type: ActionTypes.AUDIENCE_OPEN_CLOSE_DATE_UPDATE;
	payload: { openOn?: string; closeOn?: string; openImmediately: boolean };
}

export interface IAudienceDistributionTypeUpdate extends Action {
	type: ActionTypes.AUDIENCE_DISTRIBUTION_TYPE_UPDATE;
	payload: DistributionType;
}

export interface IAudienceDistributionsDataUpdate extends Action {
	type: ActionTypes.AUDIENCE_DISTRIBUTIONS_DATA_UPDATE;
	payload: { distributions: IDistributionFile[] };
}
export interface IAudienceAccessCodeUpdate extends Action {
	type: ActionTypes.AUDIENCE_ACCESS_CODE_TYPE_UPDATE;
	payload: AccessCodeType;
}
export interface IAudienceDetailsValidation extends Action {
	type: ActionTypes.AUDIENCE_EDIT_VALIDATION;
	payload: { validationError: IValidationErrorCollection };
}
export interface IAudienceDetailsNavigateStep extends Action {
	type: ActionTypes.AUDIENCE_EDIT_NAVIGATE_STEP;
	payload: { audienceDetailsStep: AudienceDetailsStep };
}
export interface IAudienceDetailsLoading extends Action {
	type: ActionTypes.AUDIENCE_DETAILS_LOADING;
	payload: boolean;
}
export interface IAudienceDetailsInitState extends Action {
	type: ActionTypes.AUDIENCE_DETAILS_INIT_STATE;
}

export interface IAudienceDetailsSaving extends Action {
	type: ActionTypes.AUDIENCE_DETAILS_SAVING;
}

export interface IAudienceDetailsSaveSuccessful extends Action {
	type: ActionTypes.AUDIENCE_DETAILS_SAVE_SUCCESSFUL;
}
export interface IAudienceDetailsSaveFailed extends Action {
	type: ActionTypes.AUDIENCE_DETAILS_SAVE_FAILED;
}
export interface IAudienceUnsavedChangesWarningModal extends Action {
	type: ActionTypes.UNSAVED_CHANGES_WARNING_MODAL;
	payload: boolean;
}

export interface IAudienceDistributionOptionDataTransferModal extends Action {
	type: ActionTypes.AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_MODAL_TOGGLE;
	payload: { open: boolean; distributionType?: DistributionType };
}
export interface IAudienceDistributionOptionDataTransferClearData extends Action {
	type: ActionTypes.AUDIENCE_DISTRIBUTION_OPTION_DATA_TRANSFER_CLEAR_DATA;
	payload: { distributionOptionDataTransferClearData: boolean };
}

// Audience - delete person attribute actions
export interface IAudienceDeleteAttributesRequested extends Action {
	type: ActionTypes.AUDIENCE_DELETE_ATTRIBUTES_REQUESTED;
}
export interface IAudienceDeleteAttributesFailed extends Action {
	type: ActionTypes.AUDIENCE_DELETE_ATTRIBUTES_FAILED;
}
export interface IAudienceDeleteAttributesSucceeded extends Action {
	type: ActionTypes.AUDIENCE_DELETE_ATTRIBUTES_SUCCEEDED;
}

export interface IAudienceSetTestAudience extends Action {
	type: ActionTypes.AUDIENCE_SET_TEST_AUDIENCE;
	payload: { isTestAudience: boolean };
}

export interface IAudienceSetSsoAttributeId extends Action {
	type: ActionTypes.AUDIENCE_SET_SSO_ATTRIBUTE_ID;
	payload: { value: SsoAttribute };
}

export interface ILocationChange extends Action {
	type: '@@router/LOCATION_CHANGE';
	payload: {};
}
